import React, { useState } from "react";
import SelecionarBusca from "../../components/SelecionarBusca";
import { Row, Col, Form, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { FiltroCabecalho } from "../../components/FiltroCabecalho";
import { ModeloGerencia } from "../../core/models/gerencia";
import { ModeloLinha } from "../../core/models/linha";
import { ModeloProduto } from "../../core/models/produto";
import { FiltroGerencia, RepositorioGerencia } from "../../core/repositories/gerenciaRepositorio";
import { FiltroLinha, RepositorioLinha } from "../../core/repositories/linhaRepositorio";
import { FiltroProduto, RepositorioProduto } from "../../core/repositories/produtoRepositorio";
import { filtroContexto } from "../../core/contexts/filtroContexto";

import { useToast } from "../../core/contexts/toast";
import { sazonalidadeContexto } from "../../core/contexts/sazonalidadeContexto";
import { useTranslation } from "react-i18next";
import { TipoTela } from "../../core/config/tipoTela";
import { FiltroSopSales } from "../../core/repositories/sopSalesRepositorio";
import ValueComponent from "../SopElementos/SopSalesValueComponent";
import MonthRangePicker from "../../components/MonthRangePicker";

interface Props {
  titulo: string;
  filtro: FiltroSopSales;
  permissaoEditar: boolean;
  atualizarFiltro: (filtro: FiltroSopSales) => void;
  filtrarDados: (filtro: FiltroSopSales) => void;
}

export default function FiltroPI(props: Props) {
  const { t } = useTranslation();
  const { mostrarToast } = useToast();

  const { lista } = sazonalidadeContexto();
  const { listaAcabamento, listaFamiliaSubgrupo, listaMercado, listaTemperatura, listaTipoProduto } = filtroContexto()

  const [listaGerencia, setListaGerencia] = useState<ModeloGerencia[]>([]);
  const [listaLinha, setListaLinha] = useState<ModeloLinha[]>([]);
  const [listaProduto, setListaProduto] = useState<ModeloProduto[]>([]);

  React.useEffect(() => {
    try {
      carregarGerencia();
      carregarLinha();
      carregarProduto();
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }, []);

  function carregarGerencia() {
    props.filtro.cod_gerencia = ""
    const filtro = new FiltroGerencia();
    filtro.cod_canal = "1";
    new RepositorioGerencia().getFilter(filtro).then((res) => {
      setListaGerencia(res);
    });
  }

  function carregarProduto() {
    props.filtro.cod_produto_capitao = ""
    const filtroProduto = new FiltroProduto();
    filtroProduto.cod_familia_subgrupo = props.filtro.cod_familia_subgrupo_produto_capitao;
    filtroProduto.cod_linha = props.filtro.cod_linha_produto_capitao;
    new RepositorioProduto().getFilter(filtroProduto).then((res) => {
      setListaProduto(res);
    });
  }

  function carregarLinha() {
    props.filtro.cod_linha_produto_capitao = ""
    const filtroLinha = new FiltroLinha();
    filtroLinha.cod_familia_subgrupo = props.filtro.cod_familia_subgrupo_produto_capitao;

    new RepositorioLinha().getFilter(filtroLinha).then((res) => {
      setListaLinha(res);
    });
  }

  return (
    <div className="stick">
      <FiltroCabecalho
        titulo={props.titulo}
        filtro={props.filtro}
        atualizarFiltro={props.atualizarFiltro}
        lista={lista}
        tipoTela={TipoTela.SAZONALIDADE}
      >
        <>
          <Row className="row-cols-2 row-cols-lg-7">

            <Col>
            <MonthRangePicker onRangeChange={(start, end) => { console.log('Início:', start); console.log('Fim:', end); }} />
        
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Business Unit")}
                optionLabel="des_linha"
                optionValue="cod_linha"
                multiple
                value={props.filtro.cod_linha_produto_capitao}
                options={listaLinha}
                onChange={(value) => {
                  props.filtro.cod_linha_produto_capitao = value
                  carregarProduto();
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Region")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product Family")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>



            <ValueComponent value={props.filtro.value} atualizarFiltro={(value) => { props.filtro.value = value; props.atualizarFiltro(props.filtro) }}></ValueComponent>

            {/* <Col>
              <SelecionarBusca
                titulo={t("Forecast in Units")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>
            <Col>
              <SelecionarBusca
                titulo={t("Average Sales Price")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col> */}







          </Row>
        </>
      </FiltroCabecalho>
    </div>
  );
}


